import { Link } from 'react-router-dom';

import { VideoTitleType } from '../../../../../types';
import { MOVIE_DETAILS_ROUTE } from '../../../../../utils/constants';

const VideoTitle = ({ id, title, overview }: VideoTitleType) => {
  return (
    <div className='pt-[20%] px-6 md:px-12 absolute text-white bg-gradient-to-r from-black w-screen aspect-video'>
      <h1 className='text-2xl md:text-6xl font-bold' data-testid={title}>
        {title}
      </h1>
      <p className='hidden 2xl:block py-6 text-lg w-1/4'>{overview || title}</p>
      <div>
        <Link
          to={MOVIE_DETAILS_ROUTE + id}
          aria-label={title}
          className='bg-white text-black py-1 md:py-4 px-3 md:px-12 text-xl rounded-lg hover:bg-opacity-80 mt-4 flex justify-center items-center w-40 md:w-56 lg:w-60'>
          Overview
          <svg
            className='rtl:rotate-180 w-3.5 h-3.5 ms-2'
            aria-hidden='true'
            xmlns='http://www.w3.org/2000/svg'
            fill='none'
            viewBox='0 0 14 10'>
            <path
              stroke='currentColor'
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth='2'
              d='M1 5h12m0 0L9 1m4 4L9 9'
            />
          </svg>
        </Link>
      </div>
    </div>
  );
};

export default VideoTitle;
